module.exports = __webpack_public_path__ + "img/09.2aa7566.png";